/* ============================================
   VAPOR MALL — Cart Management
   Handles cart drawer updates via Shopify Ajax API
   ============================================ */

(function () {
  'use strict';

  const CONFIG = window.VAPOR_MALL;

  // Remove item from cart
  document.addEventListener('click', function (e) {
    if (!e.target.matches('.cart-item__remove')) return;

    const key = e.target.dataset.key;
    if (!key) return;

    e.target.textContent = '...';

    fetch(CONFIG.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); })
      .catch(function () { e.target.textContent = 'ERROR'; });
  });

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update count in HUD
        var countEl = document.getElementById('hud-cart-count');
        if (countEl) countEl.textContent = cart.item_count;

        // Update total — show original crossed out if a discount was applied
        var totalEl = document.getElementById('cart-total');
        if (totalEl) {
          var original = (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart.total_price;
          var discounted = cart.total_price;
          var saved = original - discounted;
          if (saved > 0) {
            totalEl.innerHTML =
              '<span style="text-decoration:line-through; opacity:0.55; margin-right:8px; color:#bbb;">' + formatMoney(original) + '</span>' +
              '<span style="color:var(--vapor-green, #05ffa1);">' + formatMoney(discounted) + '</span>';
          } else {
            totalEl.textContent = formatMoney(discounted);
          }
        }

        // Rebuild cart items
        var itemsEl = document.getElementById('cart-items');
        if (!itemsEl) return;

        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<p style="color:var(--vapor-cyan);font-size:0.5rem;padding:20px;">Nothing here yet...</p>';
          return;
        }

        itemsEl.innerHTML = cart.items.map(function (item) {
          // Larger preview, natural aspect ratio — fetch a wider source and let CSS clamp
          var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_240x$1$2') : '';
          return '<div class="cart-item" data-key="' + item.key + '">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '">' : '') +
            '<div class="cart-item__info">' +
              '<span class="cart-item__title">' + item.product_title + '</span>' +
              (item.variant_title ? '<span class="cart-item__variant">' + item.variant_title + '</span>' : '') +
              '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button class="cart-item__remove" data-key="' + item.key + '">REMOVE</button>' +
          '</div>';
        }).join('');

        // Applied-discount chip under the input
        renderAppliedDiscount(cart);
      });
  }

  // Show the currently applied discount code (if any) below the input,
  // with a REMOVE button that overrides the discount cookie.
  function renderAppliedDiscount(cart) {
    var wrap = document.getElementById('cart-applied-discount');
    var codeEl = document.getElementById('cart-applied-discount-code');
    if (!wrap || !codeEl) return;
    var code = '';
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length) code = apps[0].title || apps[0].code || '';
    if (!code) {
      // Check item-level discount allocations (manual/automatic line discounts)
      var items = cart.items || [];
      for (var i = 0; i < items.length && !code; i++) {
        var allocs = items[i].discount_allocations || [];
        for (var j = 0; j < allocs.length && !code; j++) {
          var app = allocs[j].discount_application || {};
          code = app.title || app.code || '';
        }
      }
    }
    if (code) {
      codeEl.textContent = '✓ ' + code;
      wrap.classList.add('cart-drawer__applied-discount--visible');
    } else {
      codeEl.textContent = '';
      wrap.classList.remove('cart-drawer__applied-discount--visible');
    }
  }

  // Storefront GraphQL mutation for setting (or clearing) cart discount codes.
  // Pass [] to clear, or [code] to apply. This is the only reliable way on
  // Shopify's Online Store — /discount/<code> only sets a cookie.
  function storefrontSetDiscountCodes(codes) {
    var token = CONFIG.storefrontApiToken;
    if (!token) return Promise.reject(new Error('No Storefront API token configured'));

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.token) throw new Error('No cart token');
        var cartId = 'gid://shopify/Cart/' + cart.token;
        var query = [
          'mutation($cartId: ID!, $codes: [String!]!) {',
          '  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {',
          '    cart { id discountCodes { code applicable } }',
          '    userErrors { field message }',
          '  }',
          '}'
        ].join('\n');
        return fetch('/api/2024-10/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          credentials: 'same-origin',
          body: JSON.stringify({ query: query, variables: { cartId: cartId, codes: codes } })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var data = res && res.data && res.data.cartDiscountCodesUpdate;
        var errs = (res && res.errors) || (data && data.userErrors) || [];
        if (errs && errs.length) throw new Error(errs.map(function (e) { return e.message || JSON.stringify(e); }).join('; '));
        return data && data.cart;
      });
  }
  function storefrontClearDiscount() { return storefrontSetDiscountCodes([]); }

  // Remove the currently applied discount.  Primary path: Storefront GraphQL
  // cartDiscountCodesUpdate mutation (truly clears the cart).  Fallback:
  // best-effort cookie overrides (work on some stores, not all).
  var removeBtn = document.getElementById('cart-applied-discount-remove');
  if (removeBtn) {
    removeBtn.addEventListener('click', function () {
      var status = document.getElementById('cart-discount-status');
      if (status) { status.className = 'cart-drawer__discount-status'; status.textContent = 'Removing...'; }
      // Optimistic: hide the chip + clear the strikethrough total immediately.
      // If the server still returns a discount after the round-trip, refreshCart
      // will re-show the chip and restore the strikethrough.
      var wrap = document.getElementById('cart-applied-discount');
      if (wrap) wrap.classList.remove('cart-drawer__applied-discount--visible');
      var totalEl = document.getElementById('cart-total');
      if (totalEl) {
        // Strip any existing markup (strikethrough wrapper), keep only the current text
        var plainText = (totalEl.textContent || '').trim();
        // Use the last monetary amount in the string (the discounted price, if present)
        var match = plainText.match(/\$[\d.,]+/g);
        if (match && match.length) totalEl.textContent = match[match.length - 1];
      }
      var primary = storefrontClearDiscount()
        .catch(function (err) {
          // Fallback for stores without a Storefront API token configured, or
          // if the GraphQL mutation fails for some reason.
          console.warn('[VaporCart] Storefront discount clear failed, falling back:', err);
          var junk = 'g95-clr-' + Date.now();
          return fetch(CONFIG.routes.cartUpdate || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount_code: '', attributes: { _g95_applied_discount: '' } })
          })
            .then(function () { return fetch('/discount?redirect=/cart', { method: 'GET', credentials: 'same-origin', redirect: 'follow' }); })
            .then(function () { return fetch('/discount/' + junk, { method: 'GET', credentials: 'same-origin', redirect: 'follow' }); });
        });

      primary
        .then(function () {
          // refreshCart re-fetches cart.js and re-renders items + total + chip.
          // The chip hides itself when no discount is found in the response.
          refreshCart();
          if (status) {
            status.className = 'cart-drawer__discount-status is-success';
            status.textContent = 'Discount removed';
            // Auto-clear the confirmation after 2.5s
            setTimeout(function () {
              if (status.textContent === 'Discount removed') {
                status.className = 'cart-drawer__discount-status';
                status.textContent = '';
              }
            }, 2500);
          }
        })
        .catch(function () {
          if (status) { status.className = 'cart-drawer__discount-status is-error'; status.textContent = 'Could not remove'; }
        });
    });
  }

  function formatMoney(cents) {
    var format = CONFIG.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  // ---- Discount code form ----
  // Shopify doesn't have an Ajax endpoint for discounts, so we use the /discount/CODE URL
  // which sets the discount cookie. Then fetch cart.js to update display.
  // Actual discount value applies at checkout (cart JSON may reflect it via total_discount).
  var discountForm = document.getElementById('cart-discount-form');
  if (discountForm) {
    discountForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = document.getElementById('cart-discount-input');
      var status = document.getElementById('cart-discount-status');
      var code = (input.value || '').trim();
      if (!code) return;

      status.className = 'cart-drawer__discount-status';
      status.textContent = 'Applying...';

      // Primary: Storefront GraphQL cartDiscountCodesUpdate. Applies the code
      // server-side so /cart.js reflects it immediately.
      // Fallback: /discount/<code> cookie set (for stores without a Storefront token).
      var applyPrimary = storefrontSetDiscountCodes([code])
        .catch(function (err) {
          console.warn('[VaporCart] Storefront apply failed, falling back to cookie:', err);
          return fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
            .then(function () {
              return fetch(CONFIG.routes.cartUpdate || '/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ attributes: { _g95_applied_discount: code } })
              });
            });
        });

      applyPrimary
        .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          refreshCart();

          var hasCartDiscount = (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
          var hasItemDiscount = cart.items && cart.items.some(function (i) {
            return i.discount_allocations && i.discount_allocations.length > 0;
          });
          var hasTotalDiscount = cart.total_discount && cart.total_discount > 0;
          var codesApplied = cart.discount_codes && cart.discount_codes.some(function (c) { return c.applicable; });

          if (hasCartDiscount || hasItemDiscount || hasTotalDiscount || codesApplied) {
            status.className = 'cart-drawer__discount-status is-success';
            status.textContent = '✓ Code applied: ' + code.toUpperCase();
            input.value = '';
          } else {
            // Shopify accepted the code but nothing in the cart qualifies for it,
            // OR the code only applies at checkout (e.g. shipping discounts, BOGO
            // under minimums). Tell the user plainly.
            status.className = 'cart-drawer__discount-status is-error';
            status.textContent = 'Code saved — applies at checkout (not reflected in total here)';
          }
        })
        .catch(function () {
          status.className = 'cart-drawer__discount-status is-error';
          status.textContent = 'Invalid or expired code';
        });
    });
  }

  // Initial render — the drawer is pre-rendered via Liquid, but any applied
  // discount state needs to be pulled from cart.js on page load.
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderAppliedDiscount(cart); })
    .catch(function () {});

  // Expose for other scripts
  window.VaporCart = { refresh: refreshCart };
})();
